import { useEffect, useState } from 'react';
import { getEntityInvoicesFromApi } from '../../../api/accounting';
import errorMessage from '../../../helpers/errorMessage';
import { tKey } from '../../../helpers/translate';
import { InvoiceList, InvoiceListItem } from '../../../redux/accounting/definitions';

interface StateFilterData {
  [key: string]: string;
}

type UseEntityInvoiceList = {
  invoices: InvoiceListItem[];
  loading: boolean;
  stateFilters: StateFilterData;
  errorListMessage: string | null;
  removeInvoice: (invoice_id: number) => void;
};

const useEntityInvoiceList = (entity_id: number): UseEntityInvoiceList => {
  const [invoices, setInvoices] = useState<InvoiceListItem[]>([]);
  const [stateFilters, setStateFilters] = useState<StateFilterData>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [errorListMessage, setErrorListMessage] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setErrorListMessage(null);
    getEntityInvoicesFromApi(entity_id)
      .then((data: InvoiceList) => {
        setInvoices(data.invoices);
        const state_filters: StateFilterData = {};
        data.filtered_states.forEach((state: string) => {
          state_filters[state] = tKey(state);
        });

        setStateFilters(state_filters);
      })
      .catch(error => {
        setErrorListMessage(errorMessage(error));
      })
      .finally(() => setLoading(false));
  }, [entity_id]);

  const removeInvoice = (invoice_id: number) => {
    const invoicesFiltered = invoices.filter((invoice: InvoiceListItem) => invoice.id !== invoice_id);
    setInvoices(invoicesFiltered);
  };

  return {
    invoices,
    loading,
    stateFilters,
    errorListMessage,
    removeInvoice,
  };
};

export default useEntityInvoiceList;
